import { Controller } from '@hotwired/stimulus'
import { showToast } from '../utils/toast'

const ACTIVE_CLASS = 'file-drop-zone--active'

export default class extends Controller {
  static targets = ['input', 'dropZone', 'label']
  static values = {
    acceptedTypes: Array,
    invalidTypeMessage: String
  }

  openDialog() {
    this.inputTarget.click()
  }

  dragOver(event) {
    event.preventDefault()
    this.dropZoneTarget.classList.add(ACTIVE_CLASS)
  }

  dragLeave() {
    this.dropZoneTarget.classList.remove(ACTIVE_CLASS)
  }

  drop(event) {
    event.preventDefault()
    this.dropZoneTarget.classList.remove(ACTIVE_CLASS)

    const file = event.dataTransfer.files[0]
    if (!file) return

    if (!this.acceptedTypesValue.includes(file.type)) {
      this.#showError(this.invalidTypeMessageValue)
      return
    }

    this.inputTarget.files = event.dataTransfer.files
    this.#updateLabel(file.name)
  }

  fileSelected() {
    if (this.inputTarget.files.length > 0) {
      this.#updateLabel(this.inputTarget.files[0].name)
    }
  }

  #updateLabel(filename) {
    this.labelTarget.textContent = filename
  }

  #showError(message) {
    showToast('error', message)
  }
}
